export const businessImage1 = "/assets/jpg/business1.jpg";
export const businessImage2 = "/assets/jpg/business2.jpg";
export const bullseye = "/assets/svg/bullseye.svg";
export const wink = "/assets/svg/Wink.svg";
export const paperplane = "/assets/svg/paperplane.svg";
export const trophy = "/assets/svg/trophy.svg";